import React, { useState } from "react"
import PropTypes from "prop-types"
import _filter from "lodash/filter"
import { translate } from "react-i18next"
import compose from "ramda/src/compose"

import ThemeConsumer from "shared/components/ThemeConsumer"

import Options from "components/InvoicesPaid/components/Options"

const IncidentDownloadContextMenu = ({
  t,
  onDownload,
  onSendMail,
  onTrackTechnician,
  onShowProblemSolvedModal,
  showTrackTechnician,
  showProblemSolved,
  icons,
  theme,
  onAudioRequestModal
}) => {
  const [isOpened, setIsOpened] = useState(false)

  const onTriggerClick = () => {
    setIsOpened(!isOpened)
  }

  const renderTriggerButton = () => {
    const ArrowIcon = icons.Arrow

    return (
      <button type="button" onClick={onTriggerClick}>
        <ArrowIcon className={theme.icon} />
      </button>
    )
  }

  const options = [
    {
      label: t("MSG_0063"),
      handleClick: onDownload,
      id: "download",
      isShowButton: !!onDownload
    },
    {
      label: t("MSG_0045"),
      handleClick: onSendMail,
      id: "email",
      isShowButton: !!onSendMail
    },
    {
      label: t("MSG_0230"),
      handleClick: onTrackTechnician,
      id: "tracking",
      isShowButton: !!showTrackTechnician
    },
    {
      label: t("MSG_0303"),
      handleClick: onShowProblemSolvedModal,
      id: "problemSolve",
      isShowButton: !!showProblemSolved
    },
    {
      label: t("REQUEST_AUDIO"),
      handleClick: onAudioRequestModal,
      id: "audio",
      isShowButton: true
    }
  ]

  return (
    <Options
      options={_filter(options, (opt) => opt.isShowButton)}
      isOpen={isOpened}
      trigger={renderTriggerButton}
      onClose={onTriggerClick}
    />
  )
}

IncidentDownloadContextMenu.propTypes = {
  container: PropTypes.node.isRequired,
  t: PropTypes.func.isRequired,
  onDownload: PropTypes.func,
  onSendMail: PropTypes.func,
  onTrackTechnician: PropTypes.func,
  onShowProblemSolvedModal: PropTypes.func,
  showTrackTechnician: PropTypes.bool,
  showProblemSolved: PropTypes.bool,
  icons: PropTypes.object,
  theme: PropTypes.object,
  onAudioRequestModal: PropTypes.func
}

const enhace = compose(ThemeConsumer("UIInvoicesPaid"), translate())

export default enhace(IncidentDownloadContextMenu)



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/IncidentDownloadContextMenu/index.js